import { createContext, useContext } from "react";
export interface SignupState {
  getInfo: () => any;
  setInfo: (info: any) => void;
}
export const SignupContext = createContext<SignupState>({
  getInfo: () => ({}) as any,
  setInfo: () => {},
});

export const useSignup = () => {
  const context = useContext(SignupContext);
  if (!context) {
    throw new Error("useSignup must be used within a SignupProvider");
  }
  return context;
}; 